// import InputField from "components/fields/InputField";
// import { FcGoogle } from "react-icons/fc";
// import Checkbox from "components/checkbox";
// import api, { setAccessToken } from "../../api/axios";
// import { useNavigate } from "react-router-dom";
// import { useState } from "react";

// export default function SignIn() {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [errorMsg, setErrorMsg] = useState("");
//   const navigate = useNavigate();

//   const handleLogin = async (e) => {
//     e.preventDefault(); // Prevents page reload on form submission
//     setErrorMsg("");
//     setLoading(true);

//     try {
//       const credentials = {
//         email: email,
//         password: password,
//       };

//       console.log("loginUser credentials:", credentials);
//       const response = await api.post("/auth/login", credentials);

//       if (response.data.accessToken) {
//         // Store access token in memory
//         setAccessToken(response.data.accessToken);
//         const user = response.data.user;
//         const userData = {
//           role: user.role,
//           userId: user._id,
//           email: user.email,
//           permissions: user.customPermissions || [],
//           parentId: user.parent_id?._id || null,
//         };
//         if (userData.role === "masterCompany") {
//           localStorage.setItem("master_company_id", user.parent_id?._id || "");
//           localStorage.setItem("company_id", "");
//         } else if (userData.role === "staff" || userData.role === "company") {
//           localStorage.setItem("master_company_id", "");
//           localStorage.setItem("company_id", user.parent_id?._id || "");
//         } else if (userData.role === "admin") {
//           localStorage.setItem("master_company_id", "");
//           localStorage.setItem("company_id",  "");
//         }
//         // console.log("company_id",localStorage.getItem("company_id"))

//         localStorage.setItem("userData", JSON.stringify(userData));
//         // console.log("Login successful:", response.userData);
//       }

//       // Redirect to admin dashboard
//       navigate("/admin/exhibitors");
//     } catch (error) {
//       console.error("Login failed:", error);
//       setErrorMsg(
//         error.response?.data?.message ||
//           "Login failed. Please check your network or credentials."
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="mb-16 mt-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">
//       {/* Sign in section */}
//       <div className="mt-[10vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
//         <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
//           Sign In
//         </h4>
//         <p className="mb-9 ml-1 text-base text-gray-600">
//           Enter your email and password to sign in!
//         </p>

//         <div className="mb-6 flex h-[50px] w-full items-center justify-center gap-2 rounded-xl bg-lightPrimary hover:cursor-pointer dark:bg-navy-800">
//           <div className="rounded-full text-xl">
//             <FcGoogle />
//           </div>
//           <h5 className="text-sm font-medium text-navy-700 dark:text-white">
//             Sign In with Google
//           </h5>
//         </div>

//         <div className="mb-6 flex items-center gap-3">
//           <div className="h-px w-full bg-gray-200 dark:bg-navy-700" />
//           <p className="text-base text-gray-600 dark:text-white"> or </p>
//           <div className="h-px w-full bg-gray-200 dark:bg-navy-700" />
//         </div>

//         {/* Display Error Message */}
//         {errorMsg && (
//           <div className="mb-4 rounded-lg bg-red-100 p-3 text-sm text-red-600 dark:bg-red-900/30 dark:text-red-400">
//             {errorMsg}
//           </div>
//         )}

//         {/* Wrap inputs inside a FORM element */}
//         <form onSubmit={handleLogin}>
//           {/* Email */}
//           <InputField
//             variant="auth"
//             extra="mb-3"
//             label="Email*"
//             placeholder="mail@simmmple.com"
//             id="email"
//             value={email}
//             onChange={(e) => setEmail(e.target.value)}
//             type="text"
//             required
//           />

//           {/* Password */}
//           <InputField
//             variant="auth"
//             extra="mb-3"
//             label="Password*"
//             placeholder="Min. 8 characters"
//             id="password"
//             type="password"
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//             required
//           />

//           {/* Checkbox */}
//           <div className="mb-4 flex items-center justify-between px-2">
//             <div className="flex items-center">
//               <Checkbox />
//               <p className="ml-2 text-sm font-medium text-navy-700 dark:text-white">
//                 Keep me logged In
//               </p>
//             </div>
//             <a
//               className="text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-white"
//               href="#forgot-password"
//             >
//               Forgot Password?
//             </a>
//           </div>

//           <button
//             type="submit"
//             disabled={loading}
//             className="linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 disabled:opacity-50 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
//           >
//             {loading ? "Signing In..." : "Sign In"}
//           </button>
//         </form>

//         <div className="mt-4">
//           <span className="text-sm font-medium text-navy-700 dark:text-gray-600">
//             Not registered yet?
//           </span>
//           <a
//             href="#register"
//             className="ml-1 text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-white"
//           >
//             Create an account
//           </a>
//         </div>
//       </div>
//     </div>
//   );
// }
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiMail, FiLock, FiArrowRight } from "react-icons/fi";
import api, { setAccessToken } from "../../api/axios";
import AuthLayoutWrapper from "../../components/auth/AuthCardWrapper";
import { InputField } from "../../components/FormFields";
import {isObjectCompletelyFilled} from "../../utils/common"

export default function SignIn() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(true);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [error, setError] = useState({email: "", password: ""});

  const navigate = useNavigate();
  const isValidEmail = (emailStr) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailStr);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError({email: "", password: ""});
    let errorFound = false;
    if (!email) {
      setError((prev) => ({ ...prev, email: "Email is required" }));
      errorFound = true;
    }
    else if (!isValidEmail(email)) {
      setError((prev) => ({ ...prev, email: "Invalid email format" }));
      errorFound = true;
    }
    if (!password) {
      setError((prev) => ({ ...prev, password: "Password is required" }));
      errorFound = true;
    }
  
    if (errorFound) return
    
    setErrorMsg("");
    setLoading(true);


    try {
      const response = await api.post("/auth/login", { email, password });
      if (response.data.accessToken) {
        setAccessToken(response.data.accessToken);
        const user = response.data.user;
        const userData = {
          role: user.role,
          userId: user._id,
          email: user.email,
          permissions: user.customPermissions || [],
          parentId: user.parent_id?._id || null,
          parentData:user.parent_id || null
        };

        if (userData.role === "masterCompany") {
          localStorage.setItem("master_company_id", user.parent_id?._id || "");
          localStorage.setItem("company_id", "");
        } else if (userData.role === "staff" || userData.role === "company") {
          localStorage.setItem("master_company_id", "");
          localStorage.setItem("company_id", user.parent_id?._id || "");
        }
        else if (userData.role === "exhibitor") {
          localStorage.setItem("master_company_id", "");
          localStorage.setItem(
            "company_id",user.parent_id?.company_id || "");
          
        } 
        else {
          localStorage.setItem("master_company_id", "");
          localStorage.setItem("company_id", "");
        }

        localStorage.setItem("userData", JSON.stringify(userData));
        const parentObj =
          typeof user.parent_id === "object" ? user.parent_id : null;
        if (userData.role === "company") {
          navigate("/admin/visitor");
        } else if (userData.role === "exhibitor") {
          const mandatoryFields = {
            title: parentObj.title,
            exhibitor_category: parentObj.exhibitor_category,
            country: parentObj.country,
            overview: parentObj.overview,
            phone_number: parentObj.phone_number,
            logo_image: parentObj.logo_image ,
            banner_image: parentObj.banner_image,
          };
          const isComplete = isObjectCompletelyFilled(mandatoryFields || {});
          // If validation has any errors, route to edit profile page; otherwise route to exhibitor dashboard
          if (!isComplete) {
            navigate(`/admin/exhibitors/edit/${parentObj._id}`);
          } else {
            navigate("/admin/exhibitors");
          }
        } else {
          navigate("/admin/exhibitors");
        }
      }
    } catch (error) {
      setErrorMsg(
        error.response?.data?.message ||
          "Login failed. Please check credentials."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayoutWrapper>
      <div className="mb-4 text-center">
        <h3 className="text-3xl font-extrabold text-[#111827]">
          Welcome Back!
        </h3>
        <p className="mt-1 text-xs font-semibold text-[var( --color-primary)]">
          sign in to continue
        </p>
      </div>

      {errorMsg && (
        <div className="mb-3 rounded-lg bg-red-50 p-2.5 text-center text-xs font-medium text-red-600">
          {errorMsg}
        </div>
      )}

      <form
        onSubmit={handleLogin}
        className="mb-4 flex flex-1  flex-col justify-between gap-5"
      >
        <div>
          <InputField
            label="Email address"
            name="email"
            type="email"
            onChange={(e) => setEmail(e.target.value)}
            value={email}
            placeholder="Enter your email"
            icon={<FiMail className="text-[#111827]" />}
            error={error.email}
          />
          {/* <label className="mb-1 block text-xs font-semibold text-[#374151]">
            Email address
          </label>
          <div className="relative flex items-center">
            <FiMail className="absolute left-3.5 text-sm text-[#111827]" />

            <input
              type="email"
              required
              value={email}
              placeholder="Enter your email"
              onChange={(e) => setEmail(e.target.value)}
              className="focus:border-black focus:ring-black w-full rounded-xl border border-[#374151] py-2.5 pl-10 pr-3 text-xs font-medium text-gray-900 outline-none focus:ring-1"
            />
          </div> */}
        </div>

        <div>
          <InputField
            label="Password"
            name="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
            icon={<FiLock className="text-[#111827]" 
            error={error.password}
            />
              
            }
          />
          {/* <label className="mb-1 block text-xs font-semibold text-[#374151]">
            Password
          </label>
          <div className="relative flex items-center">
            <FiLock className="absolute left-3.5 text-sm text-[#111827]" />
            <input
              type={showPassword ? "text" : "password"}
              required
              value={password}
              placeholder="Enter your password"
              onChange={(e) => setPassword(e.target.value)}
              className="focus:border-black focus:ring-black w-full rounded-xl border border-[#374151] py-2.5 pl-10 pr-10 text-xs font-medium text-gray-900 outline-none focus:ring-1"
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="hover:text-black absolute right-3.5 text-sm text-gray-500"
            >
              {showPassword ? <FiEyeOff /> : <FiEye />}
            </button>
          </div> */}
        </div>

        <div className="flex items-center justify-between pt-1 text-xs">
          <label className="flex cursor-pointer items-center text-xs font-semibold text-[#374151]">
            <input
              type="checkbox"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
              className="mr-2 h-4 w-4 rounded border-gray-400 bg-gray-900 accent-[#111827]"
            />
            Remember me
          </label>
          <button
            type="button"
            onClick={() => navigate("/auth/forgot-password")}
            className="text-xs font-semibold text-[#374151] hover:underline"
          >
            Forgot password?
          </button>
        </div>

        <button
          type="submit"
          disabled={loading}
          className="mt-6 flex w-full items-center justify-center gap-2 rounded-xl bg-[#1A1A1A] py-3 text-xs font-bold tracking-wider text-[#FFFFFF] transition-all hover:bg-[#11172E] active:scale-[0.98]"
        >
          LOG IN <FiArrowRight className="text-sm" />
        </button>
      </form>
    </AuthLayoutWrapper>
  );
}
